export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const CHANGE_ITEM = 'CHANGE_ITEM';

export const SET_CATEGORY = 'SET_CATEGORY';
export const SET_DEMO_CATEGORY = 'SET_DEMO_CATEGORY';